module.exports = __webpack_public_path__ + "img/nav_bg_0.519ab93.png";